import { Helmet } from 'react-helmet-async';

/**
 * Cloudflare Web Analytics beacon. Privacy-first; no cookies, no fingerprinting.
 *
 * Mount once at the root. Disabled in DEV so local development does not
 * pollute analytics. The `data-cf-beacon` token is a public site identifier
 * (safe to commit in HTML); set it as a Pages env var named
 * `VITE_CF_ANALYTICS_TOKEN`.
 */
export function CFAnalytics() {
  const token = import.meta.env.VITE_CF_ANALYTICS_TOKEN as string | undefined;
  if (import.meta.env.DEV || !token) return null;
  const beacon = JSON.stringify({ token });
  return (
    <Helmet>
      <script
        defer
        src="https://static.cloudflareinsights.com/beacon.min.js"
        data-cf-beacon={beacon}
      />
    </Helmet>
  );
}
